import React from "react";

const FLAG_SIZE = 18;

export const UKFlag = ({ size = FLAG_SIZE, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 90"
    className={className}
    style={{ flexShrink: 0 }}
  >
    {/* White/light background with diagonal pattern */}
    <path
      d="M 88.35 57.052 c 0.034 -0.123 0.076 -0.243 0.109 -0.367 l -0.004 -0.002 C 89.457 52.957 90 49.043 90 45 c 0 -4.033 -0.54 -7.938 -1.538 -11.657 l 0.004 -0.002 c -0.039 -0.146 -0.088 -0.289 -0.128 -0.434 c -0.137 -0.492 -0.28 -0.982 -0.434 -1.468 c -0.081 -0.257 -0.167 -0.512 -0.253 -0.768 c -0.073 -0.217 -0.139 -0.437 -0.215 -0.653 h -0.015 c -1.645 -4.653 -4.021 -8.96 -7.01 -12.768 L 59.997 27.458 V 2.57 c -4.368 -1.544 -9.046 -2.427 -13.915 -2.542 h -2.164 c -4.868 0.115 -9.545 0.998 -13.913 2.541 v 24.889 L 9.589 17.249 c -2.989 3.809 -5.366 8.116 -7.01 12.769 H 2.564 c -0.076 0.216 -0.143 0.436 -0.216 0.653 c -0.086 0.255 -0.172 0.509 -0.253 0.765 c -0.154 0.486 -0.297 0.977 -0.434 1.47 c -0.04 0.145 -0.089 0.287 -0.128 0.432 l 0.004 0.002 C 0.54 37.061 0 40.966 0 45 c 0 4.043 0.543 7.957 1.545 11.684 l -0.004 0.002 c 0.033 0.123 0.074 0.242 0.108 0.365 c 0.146 0.524 0.298 1.046 0.462 1.562 c 0.075 0.236 0.154 0.47 0.233 0.705 c 0.077 0.231 0.148 0.464 0.229 0.693 H 2.59 c 1.647 4.651 4.025 8.955 7.016 12.761 l 20.4 -10.2 v 24.86 C 34.697 89.089 39.741 90 45 90 c 5.26 0 10.305 -0.911 14.997 -2.57 V 62.572 l 20.398 10.199 c 2.991 -3.806 5.368 -8.11 7.015 -12.76 h 0.015 c 0.081 -0.229 0.152 -0.463 0.23 -0.694 c 0.079 -0.234 0.158 -0.468 0.233 -0.704 C 88.052 58.096 88.205 57.575 88.35 57.052 z"
      fill="#f3f4f5"
    />
    {/* Red cross */}
    <path
      d="M 53.999 0.902 c -2.565 -0.521 -5.213 -0.81 -7.917 -0.874 h -2.164 c -2.703 0.064 -5.35 0.354 -7.914 0.874 v 35.116 H 0.899 C 0.311 38.92 0 41.924 0 45 c 0 3.087 0.312 6.1 0.904 9.012 h 35.1 v 35.087 C 38.911 89.689 41.919 90 45 90 c 3.082 0 6.091 -0.311 8.999 -0.902 V 54.012 h 35.097 C 89.688 51.1 90 48.087 90 45 c 0 -3.076 -0.311 -6.08 -0.899 -8.983 H 53.999 V 0.902 z"
      fill="#cc0000"
    />
    {/* Red diagonal accents */}
    <path d="M 85.242 65.135 c 0.829 -1.653 1.56 -3.363 2.184 -5.125 H 74.993 L 85.242 65.135 z" fill="#cc0000" />
    <path d="M 82.216 19.701 L 61.581 30.019 h 13.412 l 10.261 -5.131 C 84.353 23.088 83.341 21.354 82.216 19.701 z" fill="#cc0000" />
    <path d="M 4.747 24.887 c -0.829 1.655 -1.559 3.368 -2.182 5.132 H 15.01 L 4.747 24.887 z" fill="#cc0000" />
    <path d="M 7.8 70.321 L 28.422 60.01 H 15.01 L 4.758 65.136 C 5.661 66.936 6.674 68.67 7.8 70.321 z" fill="#cc0000" />
    {/* Blue diagonal sections */}
    <path d="M 9.589 17.249 l 20.416 10.208 v -3.99 V 2.584 C 21.874 5.458 14.813 10.593 9.589 17.249 z" fill="#000066" />
    <path d="M 59.997 2.585 v 22.302 v 2.57 L 80.411 17.25 C 75.188 10.594 68.128 5.459 59.997 2.585 z" fill="#000066" />
    <path d="M 30.006 72.77 V 62.572 l -20.4 10.2 c 5.222 6.646 12.276 11.774 20.4 14.646 V 72.77 z" fill="#000066" />
    <path d="M 59.997 62.572 v 9.296 v 15.548 c 8.123 -2.872 15.176 -8 20.398 -14.646 L 59.997 62.572 z" fill="#000066" />
    {/* Subtle border */}
    <circle cx="45" cy="45" r="44" fill="none" stroke="#e2e8f0" strokeWidth="1" />
  </svg>
);

export const UAEFlag = ({ size = FLAG_SIZE, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 90"
    className={className}
    style={{ flexShrink: 0 }}
  >
    {/* Green top stripe */}
    <path
      d="M 2.57 30 l 84.859 0 C 81.254 12.534 64.611 0.015 45.033 0 l -0.068 0 C 25.388 0.015 8.745 12.534 2.57 30 z"
      fill="#006f2e"
    />
    {/* Black bottom stripe */}
    <path
      d="M 87.429 60 L 2.57 60 C 8.749 77.476 25.408 90 45 90 S 81.25 77.476 87.429 60 z"
      fill="#000000"
    />
    {/* White middle stripe */}
    <path
      d="M 87.429 60 C 89.088 55.307 90 50.261 90 45 c 0 -5.261 -0.911 -10.307 -2.571 -15 L 2.57 30 C 0.911 34.693 0 39.739 0 45 c 0 5.261 0.912 10.307 2.571 15 L 87.429 60 z"
      fill="#f3f4f5"
    />
    {/* Red left vertical bar */}
    <path
      d="M 30 87.429 l 0 -84.858 C 12.524 8.75 0 25.408 0 45 S 12.524 81.25 30 87.429 z"
      fill="#f70000"
    />
    {/* Subtle border */}
    <circle cx="45" cy="45" r="44" fill="none" stroke="#e2e8f0" strokeWidth="1" />
  </svg>
);

export const GlobeIcon = ({ size = FLAG_SIZE, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 90"
    className={className}
    style={{ flexShrink: 0 }}
  >
    {/* Globe with grid lines */}
    <path
      d="M 45 0 C 20.187 0 0 20.187 0 45 c 0 24.813 20.187 45 45 45 c 24.813 0 45 -20.187 45 -45 C 90 20.187 69.813 0 45 0 z M 48 31.559 c 4.885 -0.239 9.636 -1.059 14.088 -2.403 C 62.971 33.151 63.535 37.48 63.71 42 H 48 V 31.559 z M 48 25.551 V 6.53 c 5.139 1.8 9.651 8.111 12.517 16.84 C 56.579 24.572 52.358 25.316 48 25.551 z M 42 6.53 v 19.021 c -4.358 -0.235 -8.579 -0.978 -12.517 -2.18 C 32.349 14.641 36.861 8.33 42 6.53 z M 42 31.559 V 42 H 26.29 c 0.175 -4.52 0.739 -8.849 1.622 -12.843 C 32.364 30.5 37.115 31.32 42 31.559 z M 20.284 42 H 6.127 c 0.565 -7.39 3.195 -14.208 7.318 -19.879 c 2.652 1.924 5.591 3.59 8.758 4.959 C 21.131 31.684 20.468 36.704 20.284 42 z M 20.284 48 c 0.184 5.296 0.847 10.317 1.919 14.921 c -3.167 1.369 -6.106 3.035 -8.758 4.959 C 9.322 62.208 6.692 55.39 6.127 48 H 20.284 z M 26.29 48 H 42 v 10.441 c -4.885 0.239 -9.636 1.059 -14.087 2.403 C 27.029 56.85 26.465 52.52 26.29 48 z M 42 64.45 v 19.02 c -5.139 -1.8 -9.65 -8.111 -12.517 -16.84 C 33.421 65.428 37.642 64.685 42 64.45 z M 48 83.47 V 64.45 c 4.358 0.235 8.579 0.978 12.517 2.18 C 57.651 75.359 53.139 81.67 48 83.47 z M 48 58.441 V 48 h 15.71 c -0.175 4.52 -0.739 8.85 -1.623 12.844 C 57.636 59.5 52.886 58.68 48 58.441 z M 69.716 48 h 14.157 c -0.565 7.39 -3.195 14.208 -7.318 19.879 c -2.652 -1.924 -5.591 -3.589 -8.758 -4.959 C 68.87 58.317 69.533 53.296 69.716 48 z M 69.716 42 c -0.184 -5.296 -0.847 -10.316 -1.919 -14.921 c 3.167 -1.369 6.106 -3.035 8.758 -4.959 C 80.679 27.792 83.308 34.61 83.873 42 H 69.716 z M 72.66 17.536 c -1.993 1.409 -4.176 2.65 -6.51 3.712 c -1.596 -4.749 -3.665 -8.889 -6.098 -12.223 C 64.804 11.02 69.08 13.931 72.66 17.536 z M 29.949 9.024 c -2.433 3.334 -4.502 7.475 -6.098 12.224 c -2.335 -1.062 -4.518 -2.302 -6.511 -3.712 C 20.92 13.931 25.196 11.02 29.949 9.024 z M 17.34 72.464 c 1.993 -1.409 4.176 -2.65 6.511 -3.712 c 1.596 4.749 3.666 8.889 6.098 12.224 C 25.196 78.98 20.92 76.069 17.34 72.464 z M 60.051 80.976 c 2.433 -3.334 4.502 -7.474 6.098 -12.223 c 2.334 1.062 4.517 2.302 6.51 3.712 C 69.08 76.069 64.804 78.98 60.051 80.976 z"
      fill="#1077b5"
    />
  </svg>
);

export const CompanyFlag = ({ company, size = FLAG_SIZE, className = "" }) => {
  switch (company) {
    case "UK":
      return <UKFlag size={size} className={className} />;
    case "UAE":
      return <UAEFlag size={size} className={className} />;
    case "Unassigned":
    default:
      return <GlobeIcon size={size} className={className} />;
  }
};

export default CompanyFlag;
